import {EntryPointFactory} from '@s-ui/domain'

const factories = {
  ads: () => import('./ads/UseCases/factory.js'),
  advertising: () => import('./advertising/UseCases/factory.js'),
  authentication: () => import('./authentication/UseCases/factory.js'),
  checkout: () => import('./checkout/UseCases/factory.js'),
  customerCare: () => import('./customerCare/UseCases/factory.js'),
  dealer: () => import('./dealer/UseCases/factory.js'),
  userFavorites: () => import('./userFavorites/UseCases/factory.js'),
  fetcher: () => import('./fetcher/UseCases/factory.js'),
  form: () => import('./form/UseCases/factory.js'),
  i18n: () => import('./i18n/UseCases/factory.js'),
  lastCall: () => import('./lastCall/UseCases/factory.js'),
  news: () => import('./news/UseCases/factory.js'),
  notifications: () => import('./notifications/UseCases/factory.js'),
  reviews: () => import('./reviews/UseCases/factory.js'),
  ratings: () => import('./ratings/UseCases/factory.js'),
  page: () => import('./page/UseCases/factory.js'),
  products: () => import('./products/UseCases/factory.js'),
  seo: () => import('./seo/UseCases/factory.js'),
  seller: () => import('./seller/UseCases/factory.js'),
  smartbanner: () => import('./smartbanner/UseCases/factory.js'),
  tracking: () => import('./tracking/UseCases/factory.js'),
  transactions: () => import('./transactions/UseCases/factory.js'),
  user: () => import('./user/UseCases/factory.js'),
  userAlerts: () => import('./userAlerts/UseCases/factory.js'),
  vehicles: () => import('./vehicles/UseCases/factory.js')
}

const adPublisherUseCases = {
  discard_draft_ad_publisher_use_case: () => import('./adPublisher/UseCases/DiscardDraftAdPublisherUseCase.js'),
  edit_draft_ad_publisher_use_case: () => import('./adPublisher/UseCases/EditDraftAdPublisherUseCase.js'),
  generate_comment_ad_publisher_use_case: () => import('./adPublisher/UseCases/GenerateCommentAdPublisherUseCase.js'),
  get_ad_publisher_use_case: () => import('./adPublisher/UseCases/GetAdPublisherUseCase.js'),
  get_empty_ad_ad_publisher_use_case: () => import('./adPublisher/UseCases/GetEmptyAdAdPublisherUseCase.js'),
  get_free_ads_available_ad_publisher_use_case: () =>
    import('./adPublisher/UseCases/GetFreeAdsAvailableAdPublisherUseCase.js'),
  obtain_draft_ad_publisher_use_case: () => import('./adPublisher/UseCases/ObtainDraftAdPublisherUseCase.js'),
  publish_ad_publisher_use_case: () => import('./adPublisher/UseCases/PublishAdPublisherUseCase.js'),
  renew_ad_publisher_use_case: () => import('./adPublisher/UseCases/RenewAdPublisherUseCase.js'),
  update_ad_publisher_use_case: () => import('./adPublisher/UseCases/UpdateAdPublisherUseCase.js'),
  upload_photo_ad_publisher_use_case: () => import('./adPublisher/UseCases/UploadPhotoAdPublisherUseCase.js'),
  upload_photo_draft_ad_publisher_use_case: () => import('./adPublisher/UseCases/UploadPhotoDraftAdPublisherUseCase.js')
}

const adsUseCases = {
  send_complaint_ads_use_case: [factories.ads, 'sendComplaintAdsUseCase'],
  get_recommended_ads_use_case: [factories.ads, 'getRecommendedAdsUseCase'],
  get_model_detail_relevant_ads_use_case: [factories.ads, 'getModelDetailRelevantAdsUseCase'],
  get_comparator_ads_use_case: () => import('./ads/UseCases/GetComparatorAdsUseCase.js'),
  add_comparator_ads_use_case: () => import('./ads/UseCases/AddComparatorAdsUseCase.js'),
  remove_comparator_ads_use_case: () => import('./ads/UseCases/RemoveComparatorAdsUseCase.js'),
  clear_comparator_ads_use_case: () => import('./ads/UseCases/ClearComparatorAdsUseCase.js'),
  get_ad_contact_phone_ads_use_case: () => import('./ads/UseCases/GetAdContactPhoneAdsUseCase.js')
}

const assistantUseCases = {
  get_existing_assisant_chat_use_case: () => import('./assistant/UseCases/CheckExistingAssistantChatUseCase.js'),
  start_assistant_new_chat_use_case: () => import('./assistant/UseCases/StartAssistantNewChatUseCase.js'),
  update_assisant_chat_use_case: () => import('./assistant/UseCases/UpdateAssistantChatUseCase.js'),
  save_assistant_chat_use_case: () => import('./assistant/UseCases/SaveAssistantChatUseCase.js'),
  load_assistant_chat_use_case: () => import('./assistant/UseCases/LoadAssistantChatUseCase.js'),
  clear_assistant_chat_use_case: () => import('./assistant/UseCases/ClearAssistantChatUseCase.js'),
  get_all_assistant_chats_use_case: () => import('./assistant/UseCases/GetAllAssistantChatsUseCase.js'),
  get_assistant_chat_suggestions_use_case: () => import('./assistant/UseCases/GetAssistantChatSuggestionsUseCase.js')
}

const checkoutUseCases = {
  create_order_checkout_use_case: [factories.checkout, 'createOrderCheckoutUseCase'],
  get_payment_methods_checkout_use_case: [factories.checkout, 'getPaymentMethodsCheckoutUseCase'],
  purchase_checkout_use_case: [factories.checkout, 'purchaseCheckoutUseCase'],
  purchase_details_checkout_use_case: [factories.checkout, 'purchaseDetailsCheckoutUseCase']
}

const dealerUseCases = {
  get_is_make_hired_dealer_use_case: () => import('./dealer/UseCases/GetIsMakeHiredDealerUseCase.js')
}

const formUseCases = {
  get_ad_complaint_config_form_use_case: [factories.form, 'getAdComplaintConfigFormUseCase'],
  get_captcha_status_form_use_case: [factories.form, 'getCaptchaStatusFormUseCase'],
  get_model_detail_config_form_use_case: [factories.form, 'getModelDetailFormConfigUseCase'],
  get_sell_vehicle_config_form_use_case: [factories.form, 'getSellVehicleConfigFormUseCase'],
  get_specs_form_use_case: () => import(`./form/UseCases/GetSpecsFormUseCase.js`),
  get_specs_url_form_use_case: () => import(`./form/UseCases/GetSpecsUrlFormUseCase.js`)
}

const lastCallUseCases = {
  create_last_call_use_case: [factories.lastCall, 'createLastCallUseCase'],
  show_last_call_use_case: [factories.lastCall, 'showLastCallUseCase']
}

const productsUseCases = {
  get_ad_products_use_case: [factories.products, 'getAdProductsUseCase'],
  get_payment_ad_products_use_case: [factories.products, 'getPaymentAdProductsUseCase'],
  get_visibility_products_use_case: [factories.products, 'getVisibilityProductsUseCase']
}

const ratingsUseCase = {
  cancel_trade_ratings_use_case: [factories.ratings, 'cancelTradeRatingsUseCase']
}

const reviewsUseCases = {
  get_news_comments_reviews_use_case: [factories.reviews, 'getNewsCommentsReviewsUseCase'],

  post_news_comment_reviews_use_case: [factories.reviews, 'postNewsCommentReviewsUseCase'],

  get_news_rating_reviews_use_case: [factories.reviews, 'getNewsRatingReviewsUseCase']
}

const searchUseCases = {
  get_search_data_from_url_search_use_case: () => import(`./search/UseCases/GetSearchDataFormUrlSearchUseCase.js`),
  get_filters_config_search_use_case: () => import(`./search/UseCases/GetFiltersConfigSearchUseCase.js`),
  get_last_search_url_use_case: () => import(`./search/UseCases/GetLastSearchUrlUseCase.js`),
  get_url_params_search_use_case: () => import(`./search/UseCases/GetUrlParamsSearchUseCase.js`),
  get_stock_url_params_search_use_case: () => import(`./search/UseCases/GetStockUrlParamsSearchUseCase.js`),
  get_aggregations_search_use_case: () => import(`./search/UseCases/GetAggregationsSearchUseCase.js`),
  get_search_request_from_ai_search_use_case: () => import(`./search/UseCases/GetSearchRequestFromAISearchUseCase.js`),
  get_results_from_search_use_case: () => import(`./search/UseCases/GetResultsFromSearchUseCase.js`),
  get_renting_search_request_from_ai_search_use_case: () =>
    import(`./search/UseCases/GetRentingSearchRequestFromAISearchUseCase.js`),
  get_faqs_for_url_search_use_case: () => import(`./search/UseCases/GetFaqsForUrlSearchUseCase.js`),
  get_ai_faqs_for_url_search_use_case: () => import(`./search/UseCases/GetAIFaqsForUrlSearchUseCase.js`)
}

const userAlertsUseCases = {
  get_alert_user_alerts_use_case: () => import(`./userAlerts/UseCases/GetAlertUserAlertsUseCase.js`),
  get_matches_user_alerts_use_case: () => import(`./userAlerts/UseCases/GetMatchesUserAlertsUseCase.js`)
}

const sellerUseCases = {
  confirm_appointment_with_dealer_seller_use_case: [factories.seller, 'confirmAppointmentWithDealerSellerUseCase'],
  contact_seller_use_case: () => import('./seller/UseCases/ContactSellerUseCase.js'),
  contact_configurator_seller_use_case: () => import('./seller/UseCases/ContactConfiguratorSellerUseCase.js'),
  contact_configurator_not_logged_seller_use_case: () =>
    import('./seller/UseCases/ContactConfiguratorNotLoggedSellerUseCase.js'),
  get_lead_configuration_seller_use_case: () => import('./seller/UseCases/GetLeadConfigurationSellerUseCase.js'),
  contact_model_seller_use_case: [factories.seller, 'contactModelSellerUseCase'],
  get_last_contact_details_seller_use_case: [factories.seller, 'getLastContactDetailsSellerUseCase'],
  get_seller_use_case: [factories.seller, 'getSellerUseCase'],
  get_recommended_price_seller_use_case: [factories.seller, 'getRecommendedPriceSellerUseCase'],
  get_close_dealers_seller_use_case: [factories.seller, 'getCloseDealersSellerUseCase'],
  get_instant_offer_by_ad_seller_use_case: [factories.seller, 'getInstantOfferByAdSellerUseCase'],
  get_instant_offer_by_id_seller_use_case: [factories.seller, 'getInstantOfferByIdSellerUseCase'],
  get_instant_offer_details_seller_use_case: () => import('./seller/UseCases/GetInstantOfferDetailsSellerUseCase.js'),
  get_simulated_instant_offer_seller_use_case: [factories.seller, 'getSimulatedInstantOfferSellerUseCase'],
  get_instant_offer_seller_use_case: () => import('./seller/UseCases/GetInstantOfferSellerUseCase.js'),
  update_instant_offer_by_id_seller_use_case: [factories.seller, 'updateInstantOfferByIdSellerUseCase'],
  update_instant_offer_seller_use_case: () => import('./seller/UseCases/UpdateInstantOfferSellerUseCase.js'),
  update_instant_offer_phone_seller_use_case: () => import('./seller/UseCases/UpdateInstantOfferPhoneSellerUseCase.js'),
  get_vehicle_draft_local_storage_seller_use_case: () =>
    import('./seller/UseCases/GetVehicleDraftLocalStorageSellerUseCase.js'),
  save_vehicle_draft_local_storage_seller_use_case: () =>
    import('./seller/UseCases/SaveVehicleDraftLocalStorageSellerUseCase.js'),
  clear_vehicle_draft_local_storage_seller_use_case: () =>
    import('./seller/UseCases/ClearVehicleDraftLocalStorageSellerUseCase.js'),
  save_instant_offer_draft_from_api_seller_use_case: () =>
    import('./seller/UseCases/SaveInstantOfferDraftFromAPISellerUseCase.js'),
  get_draft_instant_offer_from_api_seller_use_case: () =>
    import('./seller/UseCases/GetDraftInstantOfferFromAPISellerUseCase.js')
}

const vehiclesUseCases = {
  get_body_type_info_vehicles_use_case: [factories.vehicles, 'getBodyTypeInfoVehiclesUseCase'],
  get_body_type_url_params_vehicles_use_case: [factories.vehicles, 'getBodyTypeUrlParamsVehiclesUseCase'],
  get_carousels_info_vehicles_use_case: [factories.vehicles, 'getCarouselsInfoVehiclesUseCase'],
  get_carousels_sizes_info_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetCarouselsSizesInfoVehiclesUseCase.js`),
  get_configurator_body_types_options_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetConfiguratorBodyTypesOptionsVehiclesUseCase.js`),
  get_configurator_fuel_types_options_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetConfiguratorFuelTypesOptionsVehiclesUseCase.js`),
  get_configurator_makes_options_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetConfiguratorMakesOptionsVehiclesUseCase.js`),
  get_configurator_price_range_options_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetConfiguratorPriceRangeOptionsVehiclesUseCase.js`),
  get_configurator_seats_options_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetConfiguratorSeatsOptionsVehiclesUseCase.js`),
  get_suggested_vehicles_use_case: () => import(`./vehicles/UseCases/GetSuggestedVehiclesUseCase.js`),
  get_form_builder_specs_vehicles_use_case: [factories.vehicles, 'getFormBuilderSpecsVehiclesUseCase'],
  get_info_vehicles_use_case: [factories.vehicles, 'getInfoVehiclesUseCase'],
  get_is_vehicle_configurable_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetIsVehicleConfigurableVehiclesUseCase.js`),
  get_make_model_faqs_vehicles_use_case: [factories.vehicles, 'getMakeModelFaqsVehiclesUseCase'],
  get_make_model_semantics_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetMakeModelSemanticsVehiclesUseCase.js`),
  get_makes_with_models_vehicles_use_case: () => import(`./vehicles/UseCases/GetMakesWithModelsVehiclesUseCase.js`),
  get_marketed_makes_vehicles_use_case: [factories.vehicles, 'getMarketedMakesVehiclesUseCase'],
  get_model_detail_content_vehicles_use_case: () => import(`./vehicles/UseCases/GetModelDetailContentUseCase.js`),
  get_model_imaca_image_vehicles_use_case: () => import(`./vehicles/UseCases/GetModelImacaImageVehiclesUseCase.js`),
  get_model_image_vehicles_use_case: [factories.vehicles, 'getModelImageVehiclesUseCase'],
  get_model_images_vehicles_use_case: () => import(`./vehicles/UseCases/GetModelImagesVehiclesUseCase.js`),
  get_vehicle_image_vehicles_use_case: () => import(`./vehicles/UseCases/GetVehicleImageVehiclesUseCase.js`),
  get_vehicle_images_vehicles_use_case: () => import(`./vehicles/UseCases/GetVehicleImagesVehiclesUseCase.js`),
  get_model_info_vehicle_use_case: [factories.vehicles, 'getBrandModelInfoVehicleUseCase'],
  get_model_info_vehicles_use_case: [factories.vehicles, 'getModelInfoVehiclesUseCase'],
  get_model_versions_vehicles_use_case: [factories.vehicles, 'getModelVersionsUseCase'],
  get_models_grouped_by_body_type_doors_vehicles_use_case: [
    factories.vehicles,
    'getModelsGroupedByBodyTypeDoorsVehiclesUseCase'
  ],
  get_pagination_search_url_vehicles_use_case: [factories.vehicles, 'getPaginationSearchUrlVehiclesUseCase'],
  get_search_models_vehicles_use_case: () => import(`./vehicles/UseCases/GetSearchModelsVehiclesUseCase.js`),
  get_search_request_vehicles_use_case: [factories.vehicles, 'getSearchRequestVehiclesUseCase'],
  get_search_results_vehicles_use_case: [factories.vehicles, 'getSearchResultsVehiclesUseCase'],
  get_search_url_vehicles_use_case: [factories.vehicles, 'getSearchUrlVehiclesUseCase'],
  get_specs_search_url_vehicles_use_case: [factories.vehicles, 'getSpecsSearchUrlVehiclesUseCase'],
  get_specs_vehicles_use_case: [factories.vehicles, 'getSpecsVehiclesUseCase'],
  get_subscription_makes_vehicles_use_case: [factories.vehicles, 'getSubscriptionMakesVehiclesUseCase'],
  get_subscription_models_vehicles_use_case: [factories.vehicles, 'getSubscriptionModelsVehiclesUseCase'],
  get_vehicle_ai_seo_content_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetVehicleAiSeoContentVehiclesUseCase.js`),
  get_vehicle_configuration_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetVehicleConfigurationVehiclesUseCase.js`),
  get_vehicle_configurator_specs_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetVehicleConfiguratorSpecsVehiclesUseCase.js`),
  get_vehicle_content_from_ai_vehicles_use_case: () =>
    import(`./vehicles/UseCases/GetVehicleContentFromAIVehiclesUseCase.js`),
  get_vehicle_extras_vehicles_use_case: () => import(`./vehicles/UseCases/GetVehicleExtrasVehiclesUseCase.js`),
  get_vehicle_fuel_types_vehicles_use_case: () => import(`./vehicles/UseCases/GetVehicleFuelTypesVehiclesUseCase.js`),
  get_vehicle_info_by_plate_use_case: [factories.vehicles, 'getVehicleInfoByPlateUseCase'],
  get_vehicle_info_vehicles_use_case: [factories.vehicles, 'getVehicleInfoVehiclesUseCase'],
  get_vehicles_info_by_plate_use_case: [factories.vehicles, 'getVehiclesInfoByPlateUseCase'],
  get_version_info_vehicles_use_case: [factories.vehicles, 'getVersionInfoVehiclesUseCase']
}

const usersUseCases = {
  ad_share_by_email_user_use_case: [factories.user, 'adShareByEmailUserUseCase'],
  check_gigya_user_exists_user_use_case: [factories.user, 'checkGigyaUserExistsUserUseCase'],
  check_phone_verification_status_user_use_case: [factories.user, 'checkPhoneVerificationStatusUserUseCase'],
  contact_by_mail_use_case: () => import('./user/UseCases/ContactByMailUseCase.js'),
  get_mesasging_provider_token_user_use_case: () => import('./user/UseCases/GetMessagingProviderTokenUserUseCase.js'),
  get_messaging_ads_list_user_use_case: () => import('./user/UseCases/GetMessagingAdsListUserUseCase.js'),
  get_messaging_conversation_id_user_use_case: () => import('./user/UseCases/GetMessagingConversationIdUserUseCase.js'),
  get_messaging_channel_context_user_use_case: () => import('./user/UseCases/GetMessagingChannelContextUserUseCase.js'),
  upload_attachment_user_use_case: () => import('./user/UseCases/UploadAttachmentUserUseCase.js'),
  get_blocked_users_user_use_case: () => import(`./user/UseCases/GetBlockedUsersUseCase.js`),
  parse_blocked_user_cookies_use_case: () => import('./user/UseCases/ParseBlockedUserCookiesUseCase.js'),
  unblock_user_use_case: () => import('./user/UseCases/UnblockUserUseCase.js'),
  get_buyer_intentions_user_use_case: () => import('./user/UseCases/GetBuyerIntentionsUserUseCase.js'),
  check_user_email_exists_user_use_case: () => import('./user/UseCases/CheckUserEmailExistsUserUseCase.js'),
  get_default_consents_user_use_case: () => import('./user/UseCases/GetDefaultConsentsUserUseCase.js'),
  create_whatsapp_intents_user_use_case: () => import('./user/UseCases/CreateWhatsappIntentsUserUseCase.js'),
  get_consents_user_use_case: [factories.user, 'getConsentsUserUseCase'],
  get_current_user_use_case: [factories.user, 'getCurrentUserUseCase'],
  get_subscriptions_user_use_case: [factories.user, 'getSubscriptionsUserUseCase'],
  get_phone_verification_code_user_use_case: [factories.user, 'getPhoneVerificationCodeUserUseCase'],
  get_user_by_id_user_use_case: [factories.user, 'getUserByIdUserUseCase'],
  get_user_takeout_link_use_case: [factories.user, 'getUserTakeoutLinkUseCase'],
  get_user_takeout_list_use_case: [factories.user, 'getUserTakeoutListUseCase'],
  save_lead_hit_user_use_case: [factories.user, 'saveLeadHitUserUseCase'],
  send_email_to_verify_user_use_case: [factories.user, 'sendEmailToVerifyUserUseCase'],
  update_consents_user_use_case: [factories.user, 'updateConsentsUserUseCase'],
  update_data_user_use_case: [factories.user, 'updateDataUserUseCase'],
  update_password_user_use_case: [factories.user, 'updatePasswordUserUseCase'],
  update_subscriptions_user_use_case: [factories.user, 'updateSubscriptionsUserUseCase'],
  upload_avatar_user_use_case: () => import(`./user/UseCases/UploadAvatarUserUseCase.js`),
  validate_phone_verification_code_user_use_case: [factories.user, 'validatePhoneVerificationCodeUserUseCase']
}

const seoUseCases = {
  get_dealer_structured_data_use_case: [factories.seo, 'getDealerStructuredDataUseCase'],
  get_make_model_faqs_seo_use_case: [factories.seo, 'getMakeModelFaqsUseCase'],
  get_remote_seo_data_seo_use_case: () => import('./seo/UseCases/GetRemoteSeoDataSeoUseCase.js'),
  get_semantic_data_from_url_seo_use_case: [factories.seo, 'getSemanticDataFromUrlSeoUseCase'],
  get_seo_data_use_case: [factories.seo, 'getSeoDataUseCase'],
  get_vehicle_configurator_seo_data_seo_use_case: () =>
    import(`./seo/UseCases/GetVehicleConfiguratorSeoDataSeoUseCase.js`),
  get_static_faqs_seo_use_case: [factories.seo, 'getStaticFaqsSeoUseCase'],
  get_tagcloud_seo_use_case: [factories.seo, 'getTagcloudSeoUseCase']
}

const transactionsUseCases = {
  accept_purchase_terms_transactions_use_case: () =>
    import(`./transactions/UseCases/AcceptPurchaseTermsTransactionsUseCase.js`),
  create_loan_id_b2c_transactions_use_case: [factories.transactions, 'createLoanIdB2CTransactionsUseCase'],
  create_trade_transactions_use_case: () => import(`./transactions/UseCases/CreateTradeTransactionsUseCase.js`),
  confirm_agreed_price_trade_transactions_use_case: () =>
    import(`./transactions/UseCases/ConfirmAgreedPriceTradeTransactionsUseCase.js`),
  inform_agreed_price_trade_transactions_use_case: () =>
    import(`./transactions/UseCases/InformAgreedPriceTradeTransactionsUseCase.js`),
  init_trade_transactions_use_case: () => import(`./transactions/UseCases/InitTradeTransactionsUseCase.js`),
  init_payment_transactions_use_case: () => import(`./transactions/UseCases/InitPaymentTransactionsUseCase.js`),
  get_payment_initiated_transactions_use_case: () =>
    import(`./transactions/UseCases/GetPaymentInitiatedTransactionsUseCase.js`),
  get_ad_reservation_status_transactions_use_case: () =>
    import(`./transactions/UseCases/GetAdReservationStatusTransactionsUseCase.js`),
  get_reservation_by_id_transactions_use_case: () =>
    import(`./transactions/UseCases/GetReservationByIdTransactionsUseCase.js`),
  refund_reservation_transactions_use_case: () =>
    import(`./transactions/UseCases/RefundReservationTransactionsUseCase.js`),
  get_loan_calculations_transactions_use_case: () =>
    import(`./transactions/UseCases/GetLoanCalculationsTransactionsUseCase.js`),
  get_loan_url_transactions_use_case: [factories.transactions, 'getLoanUrlTransactionsUseCase'],
  get_loan_url_b2c_transactions_use_case: [factories.transactions, 'getLoanUrlB2CTransactionsUseCase'],
  get_buyer_trade_data_transactions_use_case: () =>
    import(`./transactions/UseCases/GetBuyerTradeDataTransactionsUseCase.js`),
  get_seller_trade_data_transactions_use_case: [factories.transactions, 'getSellerTradeDataTransactionsUseCase'],
  get_trade_costs_list_transactions_use_case: [factories.transactions, 'getTradeCostsListTransactionsUseCase'],
  upload_buyer_id_transactions_use_case: [factories.transactions, 'uploadBuyerIdTransactionsUseCase'],
  update_buyer_trade_data_transactions_use_case: [factories.transactions, 'updateBuyerTradeDataTransactionsUseCase'],
  update_seller_trade_data_transactions_use_case: [factories.transactions, 'updateSellerTradeDataTransactionsUseCase'],
  upload_seller_id_transactions_use_case: [factories.transactions, 'uploadSellerIdTransactionsUseCase'],
  get_trade_data_transactions_use_case: () => import('./transactions/UseCases/GetTradeDataTransactionsUseCase.js'),
  send_contracts_transactions_use_case: [factories.transactions, 'sendContractsTransactionsUseCase'],
  get_professional_activities_transactions_use_case: [
    factories.transactions,
    'getProfessionalActivitiesTransactionsUseCase'
  ],
  update_transaction_use_case: [factories.transactions, 'updateTransactionUseCase'],
  cancel_trade_buyer_transactions_use_case: () =>
    import(`./transactions/UseCases/CancelTradeBuyerTransactionsUseCase.js`),
  cancel_trade_seller_transactions_use_case: () =>
    import(`./transactions/UseCases/CancelTradeSellerTransactionsUseCase.js`),
  create_reservation_transactions_use_case: () =>
    import(`./transactions/UseCases/CreateReservationTransactionsUseCase.js`),
  init_reservation_payment_transactions_use_case: () =>
    import(`./transactions/UseCases/InitReservationPaymentTransactionsUseCase.js`),
  reject_trade_buyer_transactions_use_case: () =>
    import(`./transactions/UseCases/RejectTradeBuyerTransactionsUseCase.js`),
  reject_trade_seller_transactions_use_case: () =>
    import(`./transactions/UseCases/RejectTradeSellerTransactionsUseCase.js`),
  get_loan_calculations_B2C_transactions_use_case: [
    factories.transactions,
    'getLoanCalculationsB2CTransactionsUseCase'
  ],
  update_reservation_phone_number_transactions_use_case: () =>
    import(`./transactions/UseCases/UpdateReservationPhoneNumberTransactionsUseCase.js`)
}

const userAdsUseCases = {
  delete_user_ad_user_ads_use_case: () => import('./userAds/UseCases/DeleteUserAdUserAdsUseCase.js'),
  get_oldest_c2b_appraisable_user_ad_use_case: () =>
    import(`./userAds/UseCases/GetOldestC2bAppraisableUserAdUseCase.js`),
  get_user_ads_use_case: () => import(`./userAds/UseCases/GetUserAdsUseCase.js`),
  renew_user_ad_user_ads_use_case: () => import('./userAds/UseCases/RenewUserAdUserAdsUseCase.js')
}

const trackingUseCases = {
  get_user_traits_tracking_use_case: () => import('./tracking/UseCases/GetUserTraitsTrackingUseCase.js'),
  get_user_alerts_matches_tracking_use_case: () => import('./tracking/UseCases/GetUserAlertsMatchesTrackingUseCase.js'),
  register_csat_nps_visit_tracking_use_case: () => import('./tracking/UseCases/RegisterCsatNpsVisitTrackingUseCase.js'),
  mark_csat_nps_triggered_tracking_use_case: () => import('./tracking/UseCases/MarkCsatNpsTriggeredTrackingUseCase.js')
}

const newsBookmarksUseCases = {
  save_news_bookmarks_use_case: () => import('./newsBookmarks/UseCases/SaveNewsBookmarksUseCase.js'),
  get_saved_news_ids_use_case: () => import('./newsBookmarks/UseCases/GetSavedNewsIdsUseCase.js'),
  delete_news_bookmarks_use_case: () => import('./newsBookmarks/UseCases/DeleteNewsBookmarksUseCase.js')
}

const useCases = {
  check_open_hours_customer_care_use_case: [factories.customerCare, 'checkOpenHoursCustomerCareUseCase'],
  get_page_tracking_data_use_case: [factories.tracking, 'getPageTrackingDataUseCase'],
  get_event_tracking_data_use_case: [factories.tracking, 'getEventTrackingDataUseCase'],
  get_vehicle_configurator_event_tracking_data_use_case: () =>
    import(`./tracking/UseCases/GetVehicleConfiguratorEventTrackingDataUseCase.js`),
  get_vehicle_suggester_event_tracking_data_use_case: () =>
    import(`./tracking/UseCases/GetVehicleSuggesterEventTrackingDataUseCase.js`),
  get_vehicle_configurator_lead_tracking_data_use_case: () =>
    import(`./tracking/UseCases/GetVehicleConfiguratorLeadTrackingDataUseCase.js`),
  get_advertisements_tracking_use_case: [factories.tracking, 'getAdvertisementsTrackingUseCase'],
  get_lead_data_tracking_use_case: [factories.tracking, 'getLeadDataTrackingUseCase'],
  save_page_view_hit_tracking_use_case: [factories.tracking, 'savePageViewHitTrackingUseCase'],
  update_braze_user_use_case: [factories.tracking, 'updateBrazeUserUseCase'],
  suggest_news_search_use_case: [factories.news, 'getNewsSuggestionsUseCase'],
  get_formatted_tag_news_search_use_case: [factories.news, 'getFormattedNewsTagUseCase'],
  get_ad_details_ads_use_case: [factories.ads, 'getAdDetailsAdsUseCase'],
  get_financing_data_ads_use_case: [factories.ads, 'getFinancingDataAdsUseCase'],
  get_alert_search_ads_use_case: [factories.ads, 'getAlertSearchAdsUseCase'],
  // Experiment abtest8_web_newvehicle_call_logged_in
  get_login_url_with_lead_phone_call_ads_use_case: [factories.ads, 'getLoginUrlWithLeadPhoneCallUseCase'],
  get_navigation_links_ads_use_case: [factories.ads, 'getNavigationLinksAdsUseCase'],
  get_last_search_use_case: [factories.ads, 'getAdsFromLastSearchUseCase'],
  get_last_searches_ads_use_case: [factories.ads, 'getLastSearchesAdsUseCase'],
  save_last_ads_search_use_case: [factories.ads, 'saveLastAdsSearchUseCase'],
  save_navigation_data_ads_use_case: [factories.ads, 'saveNavigationDataAdsUseCase'],
  save_last_detail_viewed_ads_use_case: [factories.ads, 'saveLastDetailViewedAdsUseCase'],
  get_last_details_viewed_ads_use_case: [factories.ads, 'getLastDetailsViewedAdsUseCase'],
  get_search_stats_ads_use_case: [factories.ads, 'getSearchStatsAdsUseCase'],
  get_related_ads_use_case: [factories.ads, 'getRelatedAdsUseCase'],
  get_related_subscription_ads_use_case: [factories.ads, 'getRelatedSubscriptionAdsUseCase'],
  report_ads_use_case: [factories.ads, 'reportAdsUseCase'],
  get_search_url_ads_use_case: [factories.ads, 'getSearchUrlAdsUseCase'],
  get_search_pagination_url_ads_use_case: [factories.ads, 'getSearchPaginationUrlAdsUseCase'],
  get_dealer_use_case: [factories.dealer, 'getDealerUseCase'],
  get_search_results_dealer_use_case: [factories.dealer, 'getSearchResultsDealerUseCase'],
  get_search_request_dealer_use_case: [factories.dealer, 'getSearchRequestDealerUseCase'],
  get_search_url_dealer_use_case: [factories.dealer, 'getSearchUrlDealerUseCase'],
  get_pagination_search_url_dealer_use_case: [factories.dealer, 'getPaginationSearchUrlDealerUseCase'],
  get_tracking_phone_dealer_use_case: [factories.dealer, 'getTrackingPhoneDealerUseCase'],
  get_language_literals_use_case: [factories.i18n, 'getLiteralsI18nUseCase'],
  get_editorial_feed_use_case: [factories.news, 'getHomeNewsUseCase'],
  get_model_detail_news_use_case: [factories.news, 'getModelDetailNewsUseCase'],
  get_vehicle_news_use_case: [factories.news, 'getVehicleNewsUseCase'],
  get_page_name_page_use_case: [factories.page, 'getPageNamePageUseCase'],
  get_target_page_name_page_use_case: [factories.page, 'getTargetPageNamePageUseCase'],
  subscribe_editorial_use_case: [factories.news, 'subscribeToNewsletterUseCase'],
  news_search_feed_use_case: [factories.news, 'getNewsUseCase'],
  news_search_url_use_case: [factories.news, 'getNewsSearchUrlUseCase'],
  get_news_detail_use_case: [factories.news, 'getNewsDetailUseCase'],
  get_all_notifications_messaging_use_case: () =>
    import(`./notifications/UseCases/GetAllMessagingNotificationsUseCase.js`),
  get_pending_pta_notifications_use_case: [factories.notifications, 'getPendingPtaUseCase'],
  get_unread_messages_notifications_use_case: () => import(`./notifications/UseCases/GetUnreadMessagesUseCase.js`),
  get_user_profile_notifications_use_case: [factories.notifications, 'getUserProfileNotificationsUseCase'],
  set_user_profile_notifications_use_case: [factories.notifications, 'setUserProfileNotificationsUseCase'],
  send_email_validation_use_case: [factories.notifications, 'sendEmailValidationUseCase'],
  get_authentication_token_notifications_use_case: [factories.fetcher, 'getAuthenticationTokenUseCase'],
  get_configuration_advertising_use_case: [factories.advertising, 'getAdvertisingConfigurationUseCase'],
  display_ads_advertising_use_case: [factories.advertising, 'displayAdsAdvertisingUseCase'],
  get_page_data_advertising_use_case: [factories.advertising, 'getPageDataAdvertisingUseCase'],
  get_ads_dynamic_breadcrumbs_breadcrumb_use_case: () =>
    import('./breadcrumb/UseCases/GetAdsDynamicBreadcrumbsBreadcrumbUseCase.js'),
  get_news_dynamic_breadcrumbs_breadcrumb_use_case: () =>
    import('./breadcrumb/UseCases/GetNewsDynamicBreadcrumbsBreadcrumbUseCase.js'),
  get_breadcrumbs_breadcrumb_use_case: () => import('./breadcrumb/UseCases/GetBreadcrumbsBreadcrumbUseCase.js'),
  // TODO: delete unused useCase
  get_smartbanner_use_case: [factories.smartbanner, 'getSmartbannerUseCase'],
  set_smartbanner_use_case: [factories.smartbanner, 'setSmartbannerUseCase'],
  get_authentication_tracking_use_case: [factories.authentication, 'getAuthenticationTrackingUseCase'],
  login_authentication_use_case: [factories.authentication, 'loginAuthenticationUseCase'],
  notify_authentication_password_use_case: [factories.authentication, 'notifyAutenticationPasswordUseCase'],
  get_current_screenset_use_case: [factories.authentication, 'getScreensetUseCase'],
  verify_authentication_use_case: [factories.authentication, 'verifyAuthenticationUseCase'],
  get_user_favorites_use_case: [factories.userFavorites, 'getUserFavoritesUseCase'],
  add_user_favorites_use_case: [factories.userFavorites, 'addUserFavoriteUseCase'],
  delete_user_favorites_use_case: [factories.userFavorites, 'deleteUserFavoriteUseCase'],
  add_user_favorites_dealer_use_case: () => import(`./userFavorites/UseCases/AddUserFavoriteDealerUseCase.js`),
  delete_user_favorites_dealer_use_case: () => import(`./userFavorites/UseCases/DeleteUserFavoriteDealerUseCase.js`),
  unsubscribe_user_favorites_use_case: [factories.userFavorites, 'unsubscribeUserFavoriteUseCase'],
  get_search_update_ads_use_case: [factories.ads, 'getSearchUpdateAdsUseCase'],
  get_search_results_ads_use_case: [factories.ads, 'getSearchResultsAdsUseCase'],
  get_total_results_ads_use_case: [factories.ads, 'getTotalResultsAdsUseCase'],
  get_subscription_commitment_options_ads_use_case: [factories.ads, 'getSubscriptionCommitmentOptionsAdsUseCase'],
  get_subscription_carousel_ads_use_case: [factories.ads, 'getSubscriptionCarouselAdsUseCase'],
  get_login_url_for_reservation_ads_use_case: [factories.ads, 'getLoginUrlForReservationAdsUseCase'],
  get_publish_ad_tracking_usecase: [factories.tracking, 'getPublishAdTrackingUseCase'],
  create_alert_user_alert_use_case: [factories.userAlerts, 'createAlertUserAlertUseCase'],
  get_user_alerts_use_case: [factories.userAlerts, 'getUserAlertsUseCase'],
  get_user_alerts_filtered_provinces_use_case: [factories.userAlerts, 'getUserAlertsFilteredProvincesUseCase'],
  update_frequency_user_alert_use_case: [factories.userAlerts, 'updateFrequencyUserAlertUseCase'],
  update_channel_user_alert_use_case: [factories.userAlerts, 'updateChannelUserAlertUseCase'],
  update_user_alert_use_case: [factories.userAlerts, 'updateUserAlertUseCase'],
  delete_user_alert_use_case: [factories.userAlerts, 'deleteUserAlertUseCase'],
  get_unseen_saved_search_matches_use_case: [factories.userAlerts, 'getUnseenSavedSearchMatchesUseCase'],
  reset_unseen_saved_search_matches_by_id_use_case: [factories.userAlerts, 'resetUnseenSavedSearchMatchesByIdUseCase'],
  unsubscribe_user_alerts_use_case: [factories.userAlerts, 'unsubscribeUserAlertsUseCase'],
  add_user_discarded_ads_use_case: () => import(`./userDiscardedAds/UseCases/AddUserDiscardedAdsUseCase.js`),
  get_user_discarded_ads_use_case: () => import(`./userDiscardedAds/UseCases/GetUserDiscardedAdsUseCase.js`),
  sync_cookie_discarded_ads_use_case: () => import(`./userDiscardedAds/UseCases/SyncCookieDiscardedAdsUseCase.js`),
  delete_account_user_use_case: () => import(`./user/UseCases/DeleteAccountUserUseCase.js`),
  request_takeout_data_user_use_case: () => import(`./user/UseCases/RequestTakeoutDataUserUseCase.js`),
  get_latest_plates_news_use_case: () => import(`./news/UseCases/GetLatestPlatesNewsUseCase.js`),
  get_news_by_ids_news_use_case: () => import('./news/UseCases/GetNewsByIdsNewsUseCase.js'),
  get_url_page_use_case: () => import(`./page/UseCases/GetUrlPageUseCase.js`),
  ...adPublisherUseCases,
  ...adsUseCases,
  ...assistantUseCases,
  ...checkoutUseCases,
  ...dealerUseCases,
  ...formUseCases,
  ...lastCallUseCases,
  ...productsUseCases,
  ...ratingsUseCase,
  ...reviewsUseCases,
  ...searchUseCases,
  ...sellerUseCases,
  ...seoUseCases,
  ...trackingUseCases,
  ...transactionsUseCases,
  ...usersUseCases,
  ...userAdsUseCases,
  ...userAlertsUseCases,
  ...newsBookmarksUseCases,
  ...vehiclesUseCases
}

export default EntryPointFactory({useCases})
